"use strict";
/*
window.XdUtils=window.XdUtils||function(){function a(a,b){var c,d=b||{};for(c in a)a.hasOwnProperty(c)&&(d[c]=a[c]);return d}return{extend:a}}(),window.xdLocalStorage=window.xdLocalStorage||function(){function a(a){k[a.id]&&(k[a.id](a),delete k[a.id])}function b(b){var c;try{c=JSON.parse(b.data)}catch(a){}c&&c.namespace===h&&("iframe-ready"===c.id?(m=!0,i.initCallback()):a(c))}function c(a,b,c,d){j++,k[j]=d;var e={namespace:h,id:j,action:a,key:b,value:c};g.contentWindow.postMessage(JSON.stringify(e),"*")}function d(a){i=XdUtils.extend(a,i);var c=document.createElement("div");window.addEventListener?window.addEventListener("message",b,!1):window.attachEvent("onmessage",b),c.innerHTML='<iframe id="'+i.iframeId+'" src='+i.iframeUrl+' style="display: none;"></iframe>',document.body.appendChild(c),g=document.getElementById(i.iframeId)}function e(){return l?!!m||(console.log("You must wait for iframe ready message before using the api."),!1):(console.log("You must call xdLocalStorage.init() before using it."),!1)}function f(){return"complete"===document.readyState}var g,h="cross-domain-local-message",i={iframeId:"cross-domain-iframe",iframeUrl:void 0,initCallback:function(){}},j=-1,k={},l=!1,m=!0;return{init:function(a){if(!a.iframeUrl)throw"You must specify iframeUrl";if(l)return void console.log("xdLocalStorage was already initialized!");l=!0,f()?d(a):document.addEventListener?document.addEventListener("readystatechange",function(){f()&&d(a)}):document.attachEvent("readystatechange",function(){f()&&d(a)})},setItem:function(a,b,d){e()&&c("set",a,b,d)},getItem:function(a,b){e()&&c("get",a,null,b)},removeItem:function(a,b){e()&&c("remove",a,null,b)},key:function(a,b){e()&&c("key",a,null,b)},getSize:function(a){e()&&c("size",null,null,a)},getLength:function(a){e()&&c("length",null,null,a)},clear:function(a){e()&&c("clear",null,null,a)},wasInit:function(){return l}}}();

xdLocalStorage.init({
	iframeUrl:'/xdLocalStorageIframe.html',
	initCallback: function () {
		console.info('Got xdLocalStorage-iframe ready!');
	}
});
*/

function PreviewQueryCookieStorageError(code, str) {
	Error.call(this, str || code);
	this.code = code;
	this.enabled = self.$enabled;
};
PreviewQueryCookieStorageError.prototype = Object.create(Error.prototype);


/*
██████  ██████  ███████ ██    ██ ██ ███████ ██     ██  ██████  ██    ██ ███████ ██████  ██    ██ ██      ██ ███████ ████████  ██████  ███████ ██    ██ ██    ██ ██████  ███████
██   ██ ██   ██ ██      ██    ██ ██ ██      ██     ██ ██    ██ ██    ██ ██      ██   ██  ██  ██  ██      ██ ██         ██    ██    ██ ██      ██    ██ ██    ██ ██   ██ ██
██████  ██████  █████   ██    ██ ██ █████   ██  █  ██ ██    ██ ██    ██ █████   ██████    ████   ██      ██ ███████    ██    ██    ██ █████   ██    ██ ██    ██ ██████  █████
██      ██   ██ ██       ██  ██  ██ ██      ██ ███ ██ ██ ▄▄ ██ ██    ██ ██      ██   ██    ██    ██      ██      ██    ██    ██    ██ ██      ██    ██  ██  ██  ██   ██ ██
██      ██   ██ ███████   ████   ██ ███████  ███ ███   ██████   ██████  ███████ ██   ██    ██    ███████ ██ ███████    ██     ██████  ███████  ██████    ████   ██   ██ ███████
                                                          ▀▀
*/
function PreviewQueryListOeuvre(data) {
	if (data instanceof PreviewQueryListOeuvre) return data;
	this.uid         = data.uid;
	this.title       = data.title;
	this.description = data.description;
	this.width       = data.width;
	this.height      = data.height;
	this.img_uid     = data.img_uid;

	if (data.with && data.with.oeuvre) {
		this.title       = data.title   || data.with.oeuvre.title;
		this.width       = data.width   || data.with.oeuvre.width;
		this.height      = data.height  || data.with.oeuvre.height;
		this.img_uid     = data.img_uid || data.with.oeuvre.img_uid;
	}
	this.attributes  = data;
};

function PreviewQueryList(data) {
	this.local      = false;
	this.uid        = data.uid;
	this.title      = data.title;
	this.owner_uid  = data.owner_uid;
	this.created_at = data.created_at;
	this.updated_at = data.updated_at;

	var oeuvres = this.oeuvres = {};
	this.attributes = data;



/*	for(var uid in data.oeuvres || [])
		this.addOeuvres(data.oeuvres[uid]);*/
	if (data.with && data.with.client_oeuvres) {
		for(var uid in data.with.client_oeuvres || []) {
			this.oeuvres[data.with.client_oeuvres[uid].uid] = new PreviewQueryListOeuvre(data.with.client_oeuvres[uid]);
		}
	}

	this.client_oeuvres_uids = data.client_oeuvres_uids || [];
	this.client_oeuvres_uids = this.client_oeuvres_uids.filter(function(uid, i, uids){
		return uids.indexOf(uid) == i;
	}).filter(function(uid){
		return !oeuvres[uid];
	});

	if (this.client_oeuvres_uids.length > 0) {
		this._getOeuvre(this.client_oeuvres_uids)
		.then(function( items ){
			for( var i in items ){
				if (items[i] instanceof PreviewQueryListOeuvre) {
					oeuvres[items[i].uid] = items[i];
				} else console.warn("Got non instanceof PreviewQueryListOeuvre object", items[i]);
			}
		})
		.catch(function(error){
			console.error("Could not initialize PreviewQueryList", error);
		});
	}
}

PreviewQueryList.prototype._getOeuvre = function(obj) {
	var self = this;

	return window.$q(function(resolve, reject){
		try {
			if (Array.isArray(obj)) {

/*				return angular.element(document.body).injector("").get("$q")
				  .all(obj.map(function(v){
					return self._getOeuvre(v);
				})).then(resolve).catch(reject);*/

				return window.$ApiHandler.get("/clients/oeuvres/", {
					filters              : "asarray,onlydata,onlyattrs",
					clients_oeuvres_uids : obj.join(","),
					with                 : "oeuvre,images"
				}).then(function(response){
					return response.data.map(function(oeuvre){
						return new PreviewQueryListOeuvre(oeuvre);
					});
				}).then(resolve).catch(reject);

			} else if (typeof obj == "string" && (obj = obj.toUpperCase()).match(/^92[A-f0-9]{14}$/)) {

				return window.$ApiHandler.get("/clients/oeuvres/"+obj, {
					filters : "onlydata,onlyattrs",
					with    : "oeuvre,images"
				}).then(function(response){
					if (!response || !response.data || !response.data[obj]) throw new Error("Oeuvre not found!");

					return  new PreviewQueryListOeuvre(response.data[obj]);
				}).then(resolve).catch(reject);

			} else if (typeof obj == "object" && obj.uid.match(/^92[A-fa-f0-9]{14}$/) != null) {
				try {
					return resolve(new PreviewQueryListOeuvre(obj));
				} catch(e) { reject(e) }
			} else {
				throw new Error("Invalid Argument :: Argument obj must be valid UID(clients_oeuvres) or object");
			}
		} catch(e) {
			reject(e);
		}
	});
}
PreviewQueryList.prototype.addOeuvres = function(obj) {
	var self = this;
	return window.$q(function(resolve, reject){
		self._getOeuvre(obj).then(function(oeuvre) {
			try {
				if (Array.isArray(oeuvre)) {

					return window.$q.all(oeuvre.map(function(oeuvre){
						return self.addOeuvres(oeuvre);
					})).then(resolve).catch(reject);

				} else if (oeuvre instanceof PreviewQueryListOeuvre) {

					if (self.oeuvres[oeuvre.uid]) resolve(self.oeuvres[oeuvre.uid]);
					else {
//						console.log("Adding oeuvre", oeuvre, "to list", self.uid);
						resolve(self.oeuvres[oeuvre.uid] = oeuvre);
					}
				} else throw new Error("Unknow type of oeuvre");
			} catch(e) {
				reject(e);
			}
		}).catch(reject);
	});
};

PreviewQueryList.prototype.oeuvresCount = function() {
	var fullData_count = Object.keys(this.oeuvres).length;
	var refData_count  = this.client_oeuvres_uids.length;
	return Math.max(fullData_count, refData_count);
}
PreviewQueryList.prototype.clearOeuvres = function() {
	this.oeuvres = {};
	this.client_oeuvres_uids = [];
}

/*
██       ██████   ██████  █████  ██      ██████  ██████  ███████ ██    ██ ██ ███████ ██     ██  ██████  ██    ██ ███████ ██████  ██    ██ ██      ██ ███████ ████████
██      ██    ██ ██      ██   ██ ██      ██   ██ ██   ██ ██      ██    ██ ██ ██      ██     ██ ██    ██ ██    ██ ██      ██   ██  ██  ██  ██      ██ ██         ██
██      ██    ██ ██      ███████ ██      ██████  ██████  █████   ██    ██ ██ █████   ██  █  ██ ██    ██ ██    ██ █████   ██████    ████   ██      ██ ███████    ██
██      ██    ██ ██      ██   ██ ██      ██      ██   ██ ██       ██  ██  ██ ██      ██ ███ ██ ██ ▄▄ ██ ██    ██ ██      ██   ██    ██    ██      ██      ██    ██
███████  ██████   ██████ ██   ██ ███████ ██      ██   ██ ███████   ████   ██ ███████  ███ ███   ██████   ██████  ███████ ██   ██    ██    ███████ ██ ███████    ██
                                                                                                   ▀▀
*/
function LocalPreviewQueryList(data) {
	PreviewQueryList.call(this, data);
	if( !this.uid ){
		this.uid = "00";
		for( var i = 0; i < 14; i++ ) this.uid += parseInt(Math.random()*16).toString(16).toUpperCase();
	} 
	this.local = true;

}
LocalPreviewQueryList.prototype = Object.create(PreviewQueryList.prototype);
LocalPreviewQueryList.prototype.toJson = function(){
	return {
		uid					: this.uid,
		title				: this.title,
		owner_uid			: null,
		client_oeuvres_uids	: Object.keys(this.oeuvres),
		created_at			: this.created_at,
		updated_at			: this.updated_at
	};
}
LocalPreviewQueryList.FromJson = function(json){
	return new LocalPreviewQueryList({
		uid					: json.uid,
		title				: json.title,
		owner_uid			: null,
		client_oeuvres_uids	: json.client_oeuvres_uids,
		created_at			: json.created_at,
		updated_at			: json.updated_at,
		with                : json.with
	});
}








angular.module("artest.preview.query", ['ui-notification', 'ipCookie', 'ApiHandler'])

/**
 * Kirjasto hallinnoimaan teoksia
 *
 * Käyttötarpeet:
 * - lokaaliin listaan lisääminen
 * - lokaalin listan tallentaminen
 * - lokaaliin listaan teosten noutaminen sivnlatauksen yhteydessä
 *
 *
 *
 * @type {[type]}
 */
 /*
 ▄▄███▄▄·██       ██████   ██████  █████  ██      ██████  ██████  ███████ ██    ██ ██ ███████ ██     ██  ██████  ██    ██ ███████ ██████  ██    ██ ███████ ████████  ██████  ██████   █████   ██████  ███████
 ██      ██      ██    ██ ██      ██   ██ ██      ██   ██ ██   ██ ██      ██    ██ ██ ██      ██     ██ ██    ██ ██    ██ ██      ██   ██  ██  ██  ██         ██    ██    ██ ██   ██ ██   ██ ██       ██
 ███████ ██      ██    ██ ██      ███████ ██      ██████  ██████  █████   ██    ██ ██ █████   ██  █  ██ ██    ██ ██    ██ █████   ██████    ████   ███████    ██    ██    ██ ██████  ███████ ██   ███ █████
      ██ ██      ██    ██ ██      ██   ██ ██      ██      ██   ██ ██       ██  ██  ██ ██      ██ ███ ██ ██ ▄▄ ██ ██    ██ ██      ██   ██    ██         ██    ██    ██    ██ ██   ██ ██   ██ ██    ██ ██
 ███████ ███████  ██████   ██████ ██   ██ ███████ ██      ██   ██ ███████   ████   ██ ███████  ███ ███   ██████   ██████  ███████ ██   ██    ██    ███████    ██     ██████  ██   ██ ██   ██  ██████  ███████
   ▀▀▀                                                                                                      ▀▀
 */
.service("$LocalPreviewQueryStorage", ["$ApiHandler", "$User", "$q", "ipCookie", function($ApiHandler, $User, $q, ipCookie){
	var self = this;

	var storage_key = "artest_local_previewquery";
	this.$enabled = (typeof(Storage) !== "undefined");



	function useStorage_localStorage(act) {
		switch(act) {
			case "GET":    return localStorage.getItem(storage_key);
			case "SET":    return localStorage.setItem(storage_key, arguments[1] || "{}");
			case "DELETE": return localStorage.removeItem(storage_key);
		}
	};
	function useStorage_ipCookie(act) {
		var ipCookie_params = { domain : ".artest.net", path : "/"};
		switch(act) {
			case "GET":    return ipCookie(       storage_key);
			case "SET":    return ipCookie(       storage_key, (arguments[1] || "{}"), ipCookie_params);
			case "DELETE": return ipCookie.remove(storage_key,                         ipCookie_params);
		}
	};
	var useStorage = useStorage_ipCookie;

	this._get = function() {
		if (!self.$enabled) throw new PreviewQueryCookieStorageError(-1, "Storage not available");
		var json, str;
		try {
			str = useStorage("GET");
			if (typeof str == "string") json = JSON.parse(str);
			else if (typeof str == "object") json = str;
			else return null;
		} catch(e) {
			json = {};
			console.error("$LocalPreviewQueryStorage._get", e);
		}
		return (str == null) ? null : json;
	}

	this._set = function(json) {
		if (!self.$enabled) throw new PreviewQueryCookieStorageError(-1, "Storage not available");
		if (json instanceof LocalPreviewQueryList) json = json.toJson();
		var str;
		try {
			str = JSON.stringify(json);
			useStorage("SET", str);
		} catch(e) {
			console.error("$LocalPreviewQueryStorage._set", e);
		};
		return str;
	}

	this._clear = function(){
		useStorage("DELETE");
	}

	this.fetchList = function() {
		if (!self.$enabled) return reject(new PreviewQueryCookieStorageError(-1, "Storage not available"));

		var list_json = self._get();

		if (list_json == null) return null;
		return LocalPreviewQueryList.FromJson(list_json);
	}
	this.createList = function(){
		var list = {};
		list = new LocalPreviewQueryList(list);
		this.saveList(list);
		return list;
	}
	this.saveList = function(list) {
		return $q(function(resolve, reject){
			try {
				if (!(list instanceof LocalPreviewQueryList)) throw new Error("Invalid Argument");
				self._set( list );
				resolve( list );
			} catch(err) {
				reject( err );
			}
		});
	}
	this.clearList = function() {
		return this._set(list);
	}

	this.getList = function() {
		if (!self.$enabled) return reject(new PreviewQueryCookieStorageError(-1, "Storage not available"));
		var list;
		if (!(list = this.fetchList())) list = this.createList();
		
		return $q.when(list.client_oeuvres_uids.length == 0 ? {} : $ApiHandler.get("/clients/oeuvres/", {
			filters              : "asarray,onlydata,onlyattrs",
			clients_oeuvres_uids : list.client_oeuvres_uids.join(","),
			with                 : "oeuvre,images"
		})).then(function(response) {
			var oeuvres = response.data || [];
			for(var i in oeuvres) {
				try {
					var noeuvre = new PreviewQueryListOeuvre(oeuvres[i]);
					list.oeuvres[noeuvre.uid] = noeuvre;
				} catch( err ) {
					console.error("Could not initialize PreviewQueryListOeuvre", err);
				}
			}
			return list;
		})
	}
}])
/*
▄▄███▄▄·██████  ██████  ███████ ██    ██ ██ ███████ ██     ██  ██████  ██    ██ ███████ ██████  ██    ██
██      ██   ██ ██   ██ ██      ██    ██ ██ ██      ██     ██ ██    ██ ██    ██ ██      ██   ██  ██  ██
███████ ██████  ██████  █████   ██    ██ ██ █████   ██  █  ██ ██    ██ ██    ██ █████   ██████    ████
     ██ ██      ██   ██ ██       ██  ██  ██ ██      ██ ███ ██ ██ ▄▄ ██ ██    ██ ██      ██   ██    ██
███████ ██      ██   ██ ███████   ████   ██ ███████  ███ ███   ██████   ██████  ███████ ██   ██    ██
  ▀▀▀                                                             ▀▀
*/
.service("$PreviewQuery", ["$ApiHandler", "$User", "$q", "ipCookie", "$LocalPreviewQueryStorage"
                 , function($ApiHandler,   $User,   $q,   ipCookie,   $LocalPreviewQueryStorage) {
	var self = this;

	this.__ready = $q.defer();

	this.oeuvre_uids = [];
	this.list_uid = null;
	this.oeuvres = {};
	this.lists = {};

	this.$enabled = null;

	this.current_list = null;

	this.unsaved_changes = false;


	this._fetchCurrentListOeuvres = function() {
		return $q(function(resolve, reject){
			return $ApiHandler.get("/users/me/lists/oeuvres/current", {
				filters: "asarray,onlyattrs,onlydata",
				with: "client_oeuvres,oeuvre,images"
			}).then(function(response){
				var client_oeuvres = {};
				var list = response.data[0];

				for(var i in list.with.client_oeuvres)
					client_oeuvres[list.with.client_oeuvres[i].uid] = list.with.client_oeuvres[i];

				resolve({
					user_oeuvres_list : list,
					client_oeuvres    : client_oeuvres
				});
			}).catch(function(err){
				if (err.status && err.status == 404) {
					resolve({
						user_oeuvres_list : null,
						client_oeuvres    : {}
					})
				} else reject(err);
			});
		});
	}
	this._fetchLists = function() {
		return $q(function(resolve, reject) {
			var lists;
			$LocalPreviewQueryStorage.fetchLists()
			.catch(function(err){
				return {};
			})
			.then(function(local_lists){
				lists = local_lists;
				return $ApiHandler.get("/users/me/lists/oeuvres", {
					filters: "onlyattrs,onlydata"
				});
			}).then(function(response){
				for(var uid in response.data) {
					lists[uid] = new PreviewQueryList(response.data[uid]);
				}
				resolve(lists);
			}).catch(function(err){
				if (err.status && err.status == 403)
					 resolve(lists);
				else reject(err);
			});
		});
	}
	this._saveListOeuvres = function( list_uid ) {
		if ( !list_uid || typeof list_uid != "string" ) list_uid = self.current_list.uid;
		return $q(function(resolve, reject) {
			if (list_uid.substr(0,2) === "00") {

				return $LocalPreviewQueryStorage.saveList(self.local_list).then(resolve).catch(reject);

			} else if (list_uid.substr(0,2) === "9F") {
				var list = self.lists[ list_uid ];
				if ( list instanceof PreviewQueryList ) {
					return $ApiHandler.post("/users/me/lists/oeuvres/"+ list_uid, {}, {
						"user_oeuvres_list.client_oeuvres_uids": list.oeuvre_uids,
						"user_oeuvres_list.uid"                : list_uid,
						"user_oeuvres_list.owner_uid"          : list.owner_uid
					}).then(function(response) {
						for(var i in list.oeuvre_uids)
							list.oeuvres[ list.oeuvre_uids[i] ].$saved = true;

						list.unsaved_changes = false;
						resolve(response);
					}).catch(reject);
				} else return reject(new Error("Invalid argument 'list_uid' on $PreviewQuery._saveListOeuvres() :: list_uid not found on current list of lists "));
			} else return reject(new Error("invalid $PreviewQuery.current_list.uid! Not "));
		});
	}
	this.saveListOeuvres = function() {
		return this._saveListOeuvres().catch(console.error.bind(console, "$PreviewQuery.saveListOeuvres.catch"));

	}

	this._addOeuvre = function(obj) {
		return $q(function(resolve, reject) {
			if (!self.current_list)
				throw new Error("No $PreviewQuery.current_list selected");

			if (!(obj instanceof PreviewQueryListOeuvre))
				obj = new PreviewQueryListOeuvre(obj);

			obj.img_uid = obj.img_uid || obj.with.oeuvre.img_uid || Object.keys(obj.with.images)[0];

			self.current_list.oeuvres[obj.uid] = obj;
			self.current_list.client_oeuvres_uids = self.current_list.oeuvre_uids = Object.keys(self.current_list.oeuvres);
			self.unsaved_changes = true;
			resolve();
		});
	}

	this._addOeuvreToList = function(list_uid, obj) {
		return $q(function(resolve, reject) {
			var list;
			try {
				switch( list_uid.substr(0,2) ) {
					case "00": list = self.local_list; break;
					case "9F": list = self.lists[ list_uid ]; break;
					default: throw new Error( "Invalid argument as 'list_uid'" );
				}
				if ( !(list instanceof PreviewQueryList) ) throw new Error( "Invalid argument as 'list_uid' :: list not found!" );

				if (!(obj instanceof PreviewQueryListOeuvre))
					obj = new PreviewQueryListOeuvre(obj);

				obj.img_uid = obj.img_uid || obj.with.oeuvre.img_uid || Object.keys(obj.with.images)[0];

				list.oeuvres[obj.uid] = obj;
				list.client_oeuvres_uids = list.oeuvre_uids = Object.keys(list.oeuvres);
				list.unsaved_changes = true;
				resolve();

			} catch (e) {
				reject( err );
			}
		});
	}

	this._removeOeuvreByUid = function(uid) {
		return $q(function(resolve, reject) {
			delete self.current_list.oeuvres[uid];
			self.current_list.client_oeuvres_uids = self.current_list.oeuvre_uids = Object.keys(self.current_list.oeuvres);
			self.unsaved_changes = true;
			resolve(self.oeuvres);
		});
	}




	this.createAndUploadNewList = function( title ) {
		return $ApiHandler.post("/users/me/lists/oeuvres", {}, {
			"user_oeuvres_list.title" : title
		}).then(function(response){
			return self._fetchListWithOeuvres( response.headers("location").substr( -16 ) );
		}).then(function(list){
			return self.lists[ list.uid ] = list;
		});
	}


	this.getOeuvres = function(obj) {
		if (this.current_list) return this.current_list.oeuvres;
		else if (this.local_list) return this.local_list.oeuvres;
		else return {};
	}
	this.addOeuvre = function(obj) {
		return this._addOeuvre(obj).then(this._saveListOeuvres).catch(console.error.bind(console, "$PreviewQuery.addOeuvre.catch"));
	}
	this.addOeuvreByUid = function(uid, client_uid) {
		if (!uid || !client_uid) throw new Error("Cannot add oeuvre to without uid nor client_uid");
		return $q(function(resolve, reject) {
			$ApiHandler.get("/clients/"+ client_uid +"/oeuvres/"+ uid, {
				filters : "asarray,onlyattrs,onlydata",
				with    : "oeuvre,images"
			}).then(function(response) {
				if (!response.data.length) throw new Error("No oeuvre found from response.data");
				return self.addOeuvre(response.data[0])
			}).catch(reject);
		}).catch(console.error.bind(console, "$PreviewQuery.addOeuvreByUid.catch"));
	}
	this.removeOeuvreByUid = function(uid) {
		return this._removeOeuvreByUid(uid).then(this._saveListOeuvres);
	}


	this.addOeuvreToList = function(list_uid, obj) {
		return this._addOeuvreToList( list_uid, obj).then(function(){
			return self._saveListOeuvres( list_uid )
		});//.catch(console.error.bind(console, "$PreviewQuery.addOeuvre.catch"));
	}
	this.addOeuvreByUidToList = function(list_uid, client_oeuvre_uid, client_uid) {
		if (!list_uid) return this.addOeuvreByUid( client_oeuvre_uid, client_uid );

		if (!client_oeuvre_uid || !client_uid) throw new Error("Cannot add oeuvre to without uid nor client_uid");
		return $ApiHandler.get("/clients/"+ client_uid +"/oeuvres/"+ client_oeuvre_uid, {
			filters : "asarray,onlyattrs,onlydata",
			with    : "oeuvre,images"
		}).then(function(response) {
			if (!response.data.length) throw new Error("No oeuvre found from response.data");
			return self.addOeuvreToList(list_uid, response.data[0]);
		})
	}

	this.revertLocalQuery = function() {
		if (this.current_list.local) return $q.when(this.current_list);
		return this._fetchCurrentListOeuvres().then(function(obj){
			self.list_uid    = obj.user_oeuvres_list.uid;
			self.oeuvres     = {};
			self.oeuvre_uids = []
			for(var i in obj.client_oeuvres) {
				obj.client_oeuvres[i].$saved = true;
				self.addOeuvre(obj.client_oeuvres[i]);
			}
 			self.unsaved_changes = false;
			return obj;
		});
	}
	/** Päivitä APIlta kaikki tiedot viimeisimpään muotoon */
	this.reviseQueryData = function() {
		return $ApiHandler.get("/users/me/lists/oeuvres/current", {
			filters: "asarray,onlyattrs,onlydata"
		}).then(function(response) {
			console.log( response );
		}).catch(function(err) {
			console.error("Could not revise preview query data from API");
		});
	};

	this._saveList = function(uid) {
		var self = this;
		return $q(function(resolve, reject) {
			try {
				var list;
				if (!uid) {
					if (self.current_list)
						 uid = self.current_list.uid;
					else throw new Error("Invalid argument @ $PreviewQuery._saveList :: param uid not given and current_list not selected");
				}

				if (uid.substr(0,2) == "00") {
					var list = self.local_list;
					$LocalPreviewQueryStorage.saveList(list);
					resolve();
				} else if (uid.substr(0,2) == "9F") {
					var list = self.lists[uid];
					if (!list) throw new Error("Invalid argument @ $PreviewQuery._saveList :: List with uid '"+ uid +"' not found");
					return $ApiHandler.post("/users/me/lists/oeuvres/"+list.uid, {}, {
						"user_oeuvres_list.uid"       : list.uid,
						"user_oeuvres_list.owner_uid" : $User.uid,
						"user_oeuvres_list.title"     : list.title,
						"user_oeuvres_list.client_oeuvres_uids" : Object.keys(list.oeuvres)
					}).then(resolve).catch(reject);
				} else throw new Error("Invalid argument @ $PreviewQuery._saveList :: param 'uid' must be valid UID");
			} catch(e) { reject(e); }
		});
	};

	this._createNewList = function(title, uids) {
		var self = this;
		return $q(function(resolve, reject) {
			try {
				return $ApiHandler.post("/users/me/lists/oeuvres/", {}, {
					"user_oeuvres_list.title" : title,
					"user_oeuvres_list.client_oeuvres_uids" : uids,
				}).then(function(response){
					var nuid = $ApiHandler.getParsedLocation(response).pathname.substr(-16);
					resolve({
						uid : nuid,
						title: title,
						client_oeuvres_uids : uids,
						created_at: new Date(),
						updated_at: new Date(),
						owner_uid: $User.uid
					});
				}).catch(reject);
			} catch(e) { reject(e); }
		});
	}

	this._changeActiveList = function(uid) {
		return $q(function(resolve, reject) {

			try {
				if (uid == null || uid.substr(0,2) == "00") uid = null;
				else if (uid.substr(0,2) != "9F")
					throw new Error("Invalid argument @ $PreviewQuery._changeActiveList :: param 'uid' must be valid UID");

				if ( !$User.uid ) return resolve( $User.preview_query_list_uid = uid );

				return $ApiHandler.post("/users/me", {}, {
					"user.user_uid" : $User.uid,
					"user.active_preview_query_oeuvres_list_uid" : uid
				}).then(function(){
					$User.preview_query_list_uid = uid;
					resolve();
				}).catch(reject);

			} catch( err ) {
				console.error( err );
				reject( err );
			}
		});
	};

	this._fetchListWithOeuvres = function(uid) {
		return $q(function(resolve, reject) {
			try {
				if (uid.substr(0,2) == "00") {
					throw new Error("Not implementd! @ $PreviewQuery._fetchListWithOeuvres :: saving local list");
					resolve();
				} else if (uid.substr(0,2) == "9F") {
					return $ApiHandler.get("/users/me/lists/oeuvres/"+uid, {
						"filters" : "onlydata,onlyattrs",
						"with"    : "oeuvres,client_oeuvres,oeuvre"
					}).then(function(response) {
						if (!response)
							return reject(new Error("Invalid response @ $PreviewQuery._fetchListWithOeuvres"));
						if (!response.data)
							return reject(new Error("Invalid response @ $PreviewQuery._fetchListWithOeuvres :: data not found"));
						if (!response.data[uid])
							return reject(new Error("Invalid response @ $PreviewQuery._fetchListWithOeuvres :: List with uid '"+ uid +"' not found from response"));

						resolve(new PreviewQueryList(response.data[uid]));
					}).catch(reject);
				} else throw new Error("Invalid argument @ $PreviewQuery._fetchListWithOeuvres :: param 'uid' must be valid UID");
			} catch(e) { reject(e); }
		});
	}

	this._fetchRemoteLists = function() {
		var self = this;
		return $q(function(resolve, reject) {
			var lists = {};
			return $ApiHandler.get("/users/me/lists/oeuvres", {
				filters : "onlyattrs,onlydata",
				with    : "oeuvres"
			}).then(function(response) {
				var clients_oeuvres_uids = [];
				var oeuvres = {};
				var chucks = [];

				for(var uid in response.data) {
					clients_oeuvres_uids.push.apply(clients_oeuvres_uids, response.data[uid].client_oeuvres_uids);
				}

				clients_oeuvres_uids = clients_oeuvres_uids.filter(function(uid, i, uids){
					return uids.indexOf(uid)==i;
				});

				for( var i = 0; i < clients_oeuvres_uids.length; i+=15 ) {
					chucks.push(clients_oeuvres_uids.slice(i, i+15));
				}

				return $q.all(chucks.map(function(uids){
					return $ApiHandler.get("/clients/oeuvres/", {
						filters              : "onlydata,onlyattrs",
						clients_oeuvres_uids : uids.join(","),
						with                 : "oeuvre,images"
					})
				})).then(function(chucks){
					for( var i in chucks ) {
						for( var uid in chucks[i].data ) {
							oeuvres[uid] = chucks[i].data[uid];
						}
					}

					for( var uid in response.data) {
						var list = response.data[uid];
						list.client_oeuvres_uids = list.client_oeuvres_uids || [];
						list.with                = list.with                || {};
						list.with.client_oeuvres = list.with.client_oeuvres || {};

						for( var i in list.client_oeuvres_uids ) {
							list.with.client_oeuvres[list.client_oeuvres_uids[i]] = list.with.client_oeuvres[list.client_oeuvres_uids[i]] || oeuvres[list.client_oeuvres_uids[i]];
						}
					}

					return response;
				});
			}).then(function(response) {
				for(var uid in response.data) {
					lists[uid] = new PreviewQueryList(response.data[uid]);
				}
				resolve(lists);
			}).catch(function(err) {
				if (err.status && err.status == 403)
					 resolve(false);
				else reject(err);
			});
		});
	}


	this.uploadLocalList = function(local_list_uid) {
		var list = self.local_list.uid == local_list_uid ? self.local_list : null;
		if (!list && !(list = self.lists[local_list_uid]))
			return console.error("No such list with uid '"+ local_list_uid +"'", self.lists);

		console.log("Uploading list", list);
		return $q(function(resolve, reject){
			self._createNewList(list.title, list.client_oeuvres_uids).then(function(response){
				try {
					console.error("$PreviewQuery._createNewList.then", arguments);
					self.lists[response.uid] = new PreviewQueryList(response);
					return self.setActiveList(response.uid);
				} catch(e) { reject(e) }
			}).then(function(){
				try {
					console.error("$PreviewQuery._createNewList.then2", arguments);
					list.clearOeuvres();
				} catch(e) { reject(e) }
			}).catch(function(e){
				console.error("$PreviewQuery._createNewList.catch", arguments);
				reject(e);
			})
		}).catch(console.error)
	}



	this.oeuvresCount = function() {
		if (this.current_list && this.current_list.oeuvres)
			return this.current_list.oeuvresCount();
		return null;
	}


	this.fetchRemoteLists = function() {
		var self = this;
		return self._fetchRemoteLists().then(function(lists) {
			if (lists === false) {
				console.error("$PreviewQuery._fetchRemoteLists returns false :: User is not logged, is them?");
				lists = {};
			}
			return self.lists = lists;
		});
	}

	/**
	 * Vaihtaa tietueisiin oikean listan tiedot
	 * EI: Lähetä palvelimelle muutosta
	 * @see this.changeActiveList()
	 * @param {[type]} uid [description]
	 */
	this.setActiveList = function(uid) {
		var self = this;
		return $q(function(resolve, reject){
			try {
				if (!uid || uid.substr(0,2) == "00") {
					$LocalPreviewQueryStorage.getList().then(function(list){
						self.local_list = list;
						self.current_list = self.local_list;
						$User.preview_query_list_uid = uid;
						self.$current_list_is_local = true;
						resolve();
					}).catch(reject);
				} else if (uid.substr(0,2) == "9F") {
					if (!self.lists[uid]) throw new Error("Invalid Argument :: list with uid not '"+ uid +"' found");

					return self._fetchListWithOeuvres(uid)
					.then(function(list){
						self.current_list = self.lists[uid] = list;
						$User.preview_query_list_uid = uid;
						self.$current_list_is_local = false;
						resolve();
					}).catch(reject);
				} else throw new Error("Invalid Argument @ $PreviewQuery.setActiveList :: param 'uid' must be valid UID");
			} catch(e) { reject(e) }
		});
	}


	this.changeActiveList = function(uid) {
		var self = this;
		return self._saveList()
		.then(function(){
			return self._changeActiveList(uid);
		}).then(function(){
			return self.setActiveList(uid);
		});
	}

	this.revertLists = function() {
		return $q(function(resolve, reject) {

			if ($User.logged) {
				self.fetchRemoteLists().then(function(lists){
					resolve(lists);
				}).catch(reject);
			} else {
				resolve(self.lists = {});
			}
		});
	}

	this.$initialized = false;

	this.init = function() {
		self.local_list = null;
		var nactive_list = null;
		return $LocalPreviewQueryStorage.getList().then(function(list){
			self.local_list = list;
			nactive_list = self.local_list.uid;

			return $q(function(resolve, reject) {
				if (!$User.logged) return resolve();
				return self.revertLists().then(function(lists) {
					for(var i in lists)
						if (lists[i].attributes && lists[i].attributes.$active_preview_query_oeuvres_list_uid)
							nactive_list = lists[i].uid;

					resolve();
				}).catch(function(err) {
					reject(err);
				});
			});
	 	}).then(function() {
			return self.setActiveList(nactive_list)
			.catch(function(err){
				console.error(err);
			});
		}).then(function(){

/*			if (self.local_list)
				console.log("LOCAL list", self.local_list.uid, Object.keys(self.local_list.oeuvres));
			for(var i in self.lists)
				console.log("REMOTE list", self.lists[i].uid, Object.keys(self.lists[i].oeuvres));*/
			console.info("Current ArtestPreviewQuery list : ", self.current_list);

			self.$initialized = true;

			self.__ready.resolve();
		}).catch(self.__ready.reject);
	}
}])

/*
   ██████  ██    ██ ███    ██
   ██   ██ ██    ██ ████   ██
   ██████  ██    ██ ██ ██  ██
   ██   ██ ██    ██ ██  ██ ██
██ ██   ██  ██████  ██   ████
*/
.run([   "$rootScope","ipCookie","$q","$timeout","$PreviewQuery","$User","Notification","$ApiHandler",
function ($rootScope,  ipCookie,  $q,  $timeout,  $PreviewQuery,  $User,  Notification,  $ApiHandler ) {
	var previewQueryReverterTimeout;

	window.$q          = $q;
	window.$ApiHandler = $ApiHandler;

	$rootScope.$PreviewQuery = $PreviewQuery;
	$User.__ready.promise.finally(function() {
		return $timeout(function() {
			return $PreviewQuery.init()
		}, 2500 ).catch(function( err ){
			console.error("$PreviewQuery.init().catch", err);
			Notification.error({ title : "Initializing $PreviewQuery failed!", message : err.toString() });
		});
	})
	.then(function(){
	})
	.finally(function() {
		console.info("$PreviewQuery .FINALLY");
	})

	/** @todo: HyvÃ¤ksy myÃ¶s asiakaskohtaiset uid't. Atm ohitettu */
	function solveUid(oeuvre) {
		var uid;
		if (typeof oeuvre == "string") uid = oeuvre;
		else if (typeof oeuvre.uid == "string") {
			uid = oeuvre.uid;
			if (uid.substr(0,2) == "92") {
				oeuvre = oeuvre.with.oeuvre;
				uid = oeuvre.uid;
			}
		}

		if (!uid || !(uid.substr(0,2) == "82" || uid.substr(0,2) == "92")) {
			console.error("Invalid data given as oeuvre/uid", oeuvre);
			throw new Error("Invalid data given as oeuvre/uid");
		}
		return uid;
	}
}])
.directive('artestPreviewQuerySlider', function() {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {

			scope.img = angular.element(element.find("img")[0]);
			scope.width = scope.img.width();
			scope.refresh = function() {
				setTimeout(function(){
					//				scope.img.parent().width(scope.img.width());
				});
			};
			scope.img.ready(function(){
				scope.refresh();
			});
		}
	};
})
/*
 █████  ██████  ████████ ███████ ███████ ████████ ██████  ██████  ███████ ██    ██ ██ ███████ ██     ██  ██████  ██    ██ ███████ ██████  ██    ██  ██████  ██████  ███    ██ ████████ ██████   ██████  ██      ██      ███████ ██████
██   ██ ██   ██    ██    ██      ██         ██    ██   ██ ██   ██ ██      ██    ██ ██ ██      ██     ██ ██    ██ ██    ██ ██      ██   ██  ██  ██  ██      ██    ██ ████   ██    ██    ██   ██ ██    ██ ██      ██      ██      ██   ██
███████ ██████     ██    █████   ███████    ██    ██████  ██████  █████   ██    ██ ██ █████   ██  █  ██ ██    ██ ██    ██ █████   ██████    ████   ██      ██    ██ ██ ██  ██    ██    ██████  ██    ██ ██      ██      █████   ██████
██   ██ ██   ██    ██    ██           ██    ██    ██      ██   ██ ██       ██  ██  ██ ██      ██ ███ ██ ██ ▄▄ ██ ██    ██ ██      ██   ██    ██    ██      ██    ██ ██  ██ ██    ██    ██   ██ ██    ██ ██      ██      ██      ██   ██
██   ██ ██   ██    ██    ███████ ███████    ██    ██      ██   ██ ███████   ████   ██ ███████  ███ ███   ██████   ██████  ███████ ██   ██    ██     ██████  ██████  ██   ████    ██    ██   ██  ██████  ███████ ███████ ███████ ██   ██
                                                                                                            ▀▀
*/
.controller("artestPreviewQueryController", ['$rootScope', '$scope', 'Notification', 'ipCookie', '$ApiHandler', '$element', '$q', "$PreviewQuery",
                                     function($rootScope,   $scope,   Notification,   ipCookie,   $ApiHandler,   $element,   $q,   $PreviewQuery){

	$scope.slider_elem = $element.find('.oeuvres-list');

	$PreviewQuery.__ready.promise.finally(function() {
		$scope.active_preview_query_select = $PreviewQuery.current_list && $PreviewQuery.current_list.uid || null;
	});


	$rootScope.$on("refresh_preview_query", (function($scope){
	}).bind(null, $scope));

	$scope.remove = function(uid){
		$PreviewQuery.removeOeuvreByUid(uid).then(function(){
			console.log("PreviewQueryController.remove success", arguments);
		}).catch(function(e){
			console.error("PreviewQueryController.remove error", arguments);
		}).finally(function(){ });
	}
	$scope.save = function(){
		$PreviewQuery.saveListOeuvres().then(function(){
			console.log("PreviewQueryController.save success", arguments);
			Notification.success({
				title : "List '"+ $PreviewQuery.current_list.title +"' saved!"
			});
		}).catch(function(e){
			console.error("PreviewQueryController.save error", arguments);
			Notification.error({
				title   : "Could not save list '"+ $PreviewQuery.current_list.title +"'!",
				message : e.toString()
			});
		});
	}
	$scope.changeList = function(uid) {
		//$PreviewQuery._changeActiveList(uid)
		return $PreviewQuery.changeActiveList(uid)
		.then(function(){
			console.log("clearListAndSave success", arguments);
//			return $PreviewQuery.init();
		}).catch(function(err){
			console.error("PreviewQueryController.changeList error", arguments);
			Notification.error({
				title   : "Cannot change list",
				message : err.toString()
			});
		});
	}
	$scope.addByUid = function(uid, client_uid){
		$PreviewQuery.addOeuvreByUid(uid, client_uid).then(function(){
			console.log(arguments);
		}).catch(function(e){
			console.error(arguments);
		});
	}
	$scope.clearListAndSave = function(uid) {
		var list = $PreviewQuery.lists[uid];
		if (uid == $PreviewQuery.local_list.uid) list = $PreviewQuery.local_list;
		if (!list) return console.error("PreviewQueryController.clearListAndSave", "unable to found list", uid, list);

		if (!window.confirm("Are you sure you want to clear list " + (list.title || list.uid) + "?")) return;

		list.clearOeuvres();
		$PreviewQuery._saveList(uid);
	}
	$scope.destroyListAndSave = function(uid) {
		var list = $PreviewQuery.lists[uid];
		if (uid == $PreviewQuery.local_list.uid) list = $PreviewQuery.local_list;
		if (!list) return console.error("PreviewQueryController.destroyListAndSave", "unable to found list", uid, list);

		if (!window.confirm("Are you sure you want to destroy list " + (list.title || list.uid) + "?")) return;
	}


	$scope.active_preview_query_select = null;
	$scope.__tmp_changeListChangerChanged = function(_n_list_uid) {
		if (_n_list_uid) $scope.changeList( $scope.active_preview_query_select = _n_list_uid );
		else if ($scope.active_preview_query_select)  $scope.changeList($scope.active_preview_query_select);

//		var e = angular.element("#artestPreviewQueryBar .active-preview-query-selection");
//		if (e && (e = e.scope()) && e.$digest) e.$apply();
	}

	function refreshSliderItem() {

	};

/*	$scope.refreshDOM = function() {
		console.log($scope.slider_elem);
		if ($rootScope.previewQuery.oeuvres_count() === 0 ) {
			angular.element(document.getElementById("artestPreviewQueryBar")).find(".btn-clear-query").prop("disabled", true);
			angular.element(document.getElementById("artestPreviewQueryBar")).find(".btn-to-preview").prop("disabled", true);
		} else {
			angular.element(document.getElementById("artestPreviewQueryBar")).find(".btn-clear-query").prop("disabled", false);
			angular.element(document.getElementById("artestPreviewQueryBar")).find(".btn-to-preview").prop("disabled", false);
		}
		window.dragscroll.reset();
	};*/

	$rootScope.$emit("refresh_preview_query");
}])

.directive('artestPreviewQueryAddOeuvre', function(){
	return {
		templateUrl: "/ajax/cms/partials/artest-preview-query-add-to-preview-btn.html",
		scope: {
			"clientUid":       '@',
			"clientOeuvreUid": '@',
		},
		replace: true,
		controllerAs: "$ctrl",
		controller: ["$scope", "$rootScope", "$element", "$PreviewQuery", "Notification", "$User", "$timeout", function($scope, $rootScope, $element, $PreviewQuery, Notification, $User, $timeout) {
			var $ctrl = this;
			$ctrl.$User = $User;

			$ctrl.client_uid        = $scope.clientUid;
			$ctrl.client_oeuvre_uid = $scope.clientOeuvreUid;

			$ctrl.new_list_title = "";
			$ctrl.creating       = false;
			$ctrl.change_list_menu_open = false;

			$ctrl.$PreviewQuery = $PreviewQuery;

			$ctrl.addToList = function( list_uid ) {
				return $PreviewQuery.addOeuvreByUidToList( list_uid, $ctrl.client_oeuvre_uid, $ctrl.client_uid );
			}
			$ctrl.togglemenu = function(open){
				$ctrl.creating = false;
				$ctrl.change_list_menu_open = false;
				$timeout(function(){
					if (open || $rootScope.__current_artest_preview_query_add_oeuvre_ctrl_client_oeuvre_uid != $ctrl.client_oeuvre_uid) {
						$rootScope.__current_artest_preview_query_add_oeuvre_ctrl_client_oeuvre_uid = $ctrl.client_oeuvre_uid;
						$rootScope.__current_artest_preview_query_add_oeuvre_ctrl = $ctrl;
					} else {
//						delete $rootScope.__current_artest_preview_query_add_oeuvre_ctrl;
					}
				});
			};
			$ctrl.toggle_list_menu = function( $event ) {
				$event.preventDefault();
				$event.stopPropagation();
			};

			$ctrl.changeActiveList = function( list_uid ) {
				$PreviewQuery.changeActiveList( list_uid )
				.then(function(){
					console.log("clearListAndSave success", arguments);
					return $ctrl.addToList ( list_uid ) ;

				}).catch(function(err){
					console.error("PreviewQueryController.changeList error", arguments);
					Notification.error({
						title   : "Cannot change list",
						message : err.toString()
					});
				});
			};

			$ctrl.createList = function() {
				Notification.info("Creating list with title '"+ $ctrl.new_list_title +"'")
				$PreviewQuery.createAndUploadNewList( $ctrl.new_list_title ).then(function( list ){
					console.log( list );
					Notification.success("List created!", list);
					$ctrl.new_list_title = "";
					$ctrl.creating       = false;
				}).catch(function( err ){
					Notification.error( "Creating new oeure list failed!" );
					console.error( "Creating new oeure list failed!", err );
				})
			}

			$ctrl.addAndRedirectTo = function( url ){
				url = url || $rootScope.artestRootDomain+"/preview/#!/fast-preview";
				url = url + "?pouid="+$ctrl.client_oeuvre_uid;
				if ($rootScope.client_uid && $rootScope.atm_at_cmsengine) url += "&redirect_client="+$rootScope.client_uid;

				$PreviewQuery.addOeuvreByUidToList( $PreviewQuery.local_list.uid, $ctrl.client_oeuvre_uid, $ctrl.client_uid ).then(function(resolve){
					location.href = url
//					var thisIsAnObject = { foo : 'bar' };
//					window.IKKUNA = window.open(url, "_blank");
//					window.IKKUNA.myVariable = thisIsAnObject;
				}).catch(function(err){
					console.error( err );
				});
			}
		}]
	}
});

/**
 * @fileoverview dragscroll - scroll area by dragging
 * @version 0.0.8
 *
 * @license MIT, see http://github.com/asvd/dragscroll
 * @copyright 2015 asvd <heliosframework@gmail.com>
 */


(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['exports'], factory);
    } else if (typeof exports !== 'undefined') {
        factory(exports);
    } else {
		if (!root && typeof window !== 'undefined') root = window;
		if (!root && typeof globalThis !== 'undefined') root = globalThis;

        factory((root.dragscroll = {}));
    }
}(this, function (exports) {
    var _window = window;
    var _document = document;
    var mousemove = 'mousemove';
    var mouseup = 'mouseup';
    var mousedown = 'mousedown';
    var EventListener = 'EventListener';
    var addEventListener = 'add'+EventListener;
    var removeEventListener = 'remove'+EventListener;
    var newScrollX, newScrollY;

    var dragged = [];
    var reset = function(i, el) {
        for (i = 0; i < dragged.length;) {
            el = dragged[i++];
            el = el.container || el;
            el[removeEventListener](mousedown, el.md, 0);
            _window[removeEventListener](mouseup, el.mu, 0);
            _window[removeEventListener](mousemove, el.mm, 0);
        }

        // cloning into array since HTMLCollection is updated dynamically
        dragged = [].slice.call(_document.getElementsByClassName('dragscroll'));
        for (i = 0; i < dragged.length;) {
            (function(el, lastClientX, lastClientY, pushed, scroller, cont){
                (cont = el.container || el)[addEventListener](
                    mousedown,
                    cont.md = function(e) {
                        if (!el.hasAttribute('nochilddrag') ||
                            _document.elementFromPoint(
                                e.pageX, e.pageY
                            ) == cont
                        ) {
                            pushed = 1;
                            lastClientX = e.clientX;
                            lastClientY = e.clientY;

                            e.preventDefault();
                        }
                    }, 0
                );

                _window[addEventListener](
                    mouseup, cont.mu = function() {pushed = 0;}, 0
                );

                _window[addEventListener](
                    mousemove,
                    cont.mm = function(e) {
                        if (pushed) {
                            (scroller = el.scroller||el).scrollLeft -=
                                newScrollX = (- lastClientX + (lastClientX=e.clientX));
                            scroller.scrollTop -=
                                newScrollY = (- lastClientY + (lastClientY=e.clientY));
                            if (el == _document.body) {
                                (scroller = _document.documentElement).scrollLeft -= newScrollX;
                                scroller.scrollTop -= newScrollY;
                            }
                        }
                    }, 0
                );
             })(dragged[i++]);
        }
    }


    if (_document.readyState == 'complete') {
        reset();
    } else {
        _window[addEventListener]('load', reset, 0);
    }

    exports.reset = reset;
}));
